import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListCampaignComponent } from './list-campaign/list-campaign.component';

const routes: Routes = [
  { path: '', component: ListCampaignComponent },
  { path: '', pathMatch: 'full', redirectTo: 'admin/campaign' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignManagementRoutingModule {}
